// extracted by mini-css-extract-plugin
module.exports = {"header":"panel_header__34Xe1","body":"panel_body__3Cxl-","left":"panel_left__2SsLQ","right":"panel_right__12taH"};